import React from 'react';
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';
import { toast } from "react-hot-toast";
import '../../css/Home.css';

const ContactUs = () => {
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm('service_7a35jrd', 'template_qwcwytn', e.target, 'g2didnOgLaun3e8SD')
      .then((response) => {
        toast.success("Email Sent Successfully");
        e.target.reset();
      })
      .catch((error) => {
        toast.error("Failed to send email. Please try again.");
      });
  };

  return (
    <div className="contact-page container py-5">
      <h1 className="text-center fw-bold mb-5">Contact Us</h1>

      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card p-5">
            <form onSubmit={sendEmail}>
              <div className="mb-3">
                <label htmlFor="emailFrom" className="form-label">Your Email Address</label>
                <input type="email" name="email_from" id="emailFrom" className="form-control" placeholder="you@example.com" required />
              </div>

              <div className="mb-3">
                <label htmlFor="phoneNum" className="form-label">Your Phone Number</label>
                <input type="tel" name="phoneNum" id="phoneNum" className="form-control" placeholder="03XXXXXXXXX" required />
              </div>

              <div className="mb-4">
                <label htmlFor="message" className="form-label">Your Message</label>
                <textarea name="message" id="message" className="form-control" rows="5" placeholder="How can we help you?" required />
              </div>

              <button type="submit" className="btn btn-primary w-100 py-2" id="contactusbtnid">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <p className="text-secondary mb-3 fw-semibold">Connect with us</p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Link to="https://api.whatsapp.com/send?phone=923018233355" target="_blank" className="btn btn-success">
            <i className="bi bi-whatsapp"></i> WhatsApp
          </Link>
          <Link to="mailto:info@mbztransport.com" target="_blank" className="btn btn-dark">
            <i className="bi bi-envelope"></i> Email Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;